import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { EyeIcon, HeartIcon } from "@heroicons/react/24/outline";
import { MemoryIcon } from "@/assets/icons";
import CreativeScoreTooltipImg from "@/assets/report-assets/creative-score-tooltip.png";

/*
 * CreativeImpactInfoModal component
 *
 * This modal displays information about the Creative Impact and its three KPIs:
 * Attention, Emotion, and Memory.
 */
export const CreativeImpactInfoModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2>Creative Impact</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0" />
      </div>

      {/* Creative Impact tooltip image */}
      <div className="flex items-center justify-center">
        <img src={CreativeScoreTooltipImg} alt="Creative Impact visualization" className="w-full  max-w-56 rounded-lg" />
      </div>

      {/* Description */}
      <p className="text-center">Overall score that captures the power of your creative asset to capture attention, be remembered and evoke an emotional response.</p>

      {/* KPI Sections */}
      <div className="flex flex-col gap-4">
        {/* Attention */}
        <div className="p-4 bg-base-200 rounded-lg">
          <div className="flex gap-3 items-center">
            <EyeIcon className="size-5 flex-shrink-0" />
            <h3 className="font-semibold">Attention</h3>
          </div>
          <p className="text-sm mt-2">How well does the asset capture the viewer&apos;s attention?</p>
        </div>

        {/* Emotion */}
        <div className="p-4 bg-base-200 rounded-lg">
          <div className="flex gap-3 items-center">
            <HeartIcon className="size-5 flex-shrink-0" />
            <h3 className="font-semibold">Emotion</h3>
          </div>
          <p className="text-sm mt-2">Is the asset likely to evoke a strong emotional response?</p>
        </div>

        {/* Memory */}
        <div className="p-4 bg-base-200 rounded-lg">
          <div className="flex gap-3 items-center">
            <MemoryIcon outline className="size-5 flex-shrink-0" />
            <h3 className="font-semibold">Memory</h3>
          </div>
          <p className="text-sm mt-2">Is the asset likely to be remembered by the viewer?</p>
        </div>
      </div>
    </div>
  );
};
